<template>
     <div class="postsummary">         
        <template v-if="!isLoading && summary[0]">
            <div class="recent_posts" v-for="(sub, index) in subMenus" :key="index">       
                <div class="post_block">
                    <div class="title">
                        <span>{{sub.title}}</span>
                        <span class="more" @click="moreview('Community',sub.name,'isMobile')"> + </span>
                    </div>
           
                    <div v-if="summary[index]" class="cont_wrapper">                        
                        <div class="type_blog">                               
                            <div   v-for="(post, pindex) in summary[index]" :key="pindex" class="blog_block">
                                <post-content :post="post" imgheight="50px" imgwidth="70px" radius="5" mode="blog_right" isMobile="isMobile"/>
                            </div>                                
                        </div>
                    </div>                 
                </div>
            </div>  
        </template>
        <template v-else>
            <div class="loading-spinner">
                <base-spinner></base-spinner>
            </div>
        </template>       
       
    </div>   
   
</template>
<script>
import PostContent from '@/components/posts/PostContent';
import { updateMenu, morelink } from '@/utils/menu.js';
export default {
    name:'mobile_postSummary',
    props:[
        'menu_name','active'   
    ],
    data(){
        return{
            subMenus:'',
            summary:[],
            isLoading: true
        }
    },
    mixins:[

    ],
    components:{
        PostContent
    },
    watch:{
        active(data)
        {
            //alert(roomid);
            if(data)
            {
               this.getSub();
            }
        }
    },
    methods:{
        moreview(menu,post,ismobile){
            updateMenu(menu,'all', this.$store); 
            morelink(menu,post,ismobile, this.$router)   
        },
        getSub(){
            //swiper가 현재 화면일때 데이터 가져온다.
            if(this.active)
            {
                //해당 메뉴의 하위 게시판 목록을 가져온다.
                this.subMenus =  this.$store.getters['menu/getMenu'].find((menus)=>menus.name === this.menu_name).subs[0];
                
                console.log('서브메뉴확인',this.subMenus);
                //데이터 생성
                this.subMenus.forEach((e,i) => {
                    // e는 element의 e 이고 i는 index의 i, a는 array의 a 입니다.    
                    this.getPost(e.name , 3,i );                         
                });
                this.isLoading = false;
            }
           
        },
        async getPost(get,limit, index){
            const data={document:get,user_id:this.$store.getters.currentUser.id, limit:limit};
            try {
                const response = await this.$store.dispatch("posts/getRecent",data);
                console.log('포스트서머리체크',response);
                this.summary[index] =  response;   
            }catch(error){
                console.log(error.response);
            }              
        }
    }
}
</script>
<style lang="scss" scoped>
.postsummary{
      .recent_posts
    {   
        margin-bottom:10px;
        background:#fff;
        .title_wrap{
            padding: 20px 0 0 20px;
            font-family: '맑은고딕';
            border-bottom:1px dotted #ddd;
            padding-bottom:10px;
        }
    
        .post_block{
            width:100%;
            padding:20px;
            .title{
                font-weight:bold;
                font-size:1.5rem;
                font-family:'맑은고딕';
                display: flex;
                justify-content: space-between;
                .more{
                    cursor: pointer;
                    color: #fff;
                    margin: 2px;
                    background: #ddd;
                    border-radius: 3px;
                    line-height: 14px;                
                    padding: 0 2px;          
                }
                .more:hover{
                transform: translateY(-1px);
                    box-shadow: 0 7px 14px rgba(50, 50, 93, 0.2); 
                }
            }
            .title >span{
                font-size:1.2rem;
            }
            .cont_wrapper{
            margin-top:10px;
                .type_img{
                    display:flex;
                    justify-content: space-between;                       
                }
                .type_img > div{
                    width:49%;
                }
                .type_img > div:nth-child(2){              
                    margin-left:10px;                
                }

                .list_type{
                    padding-left:10px;
                }
                .type_list{
                    margin-top:10px;
                }
                .type_blog{
                    .blog_block{
                        margin-bottom:10px;
                    }                    
                }
                .type_photo{
                    display:flex;   
                    flex-wrap:wrap;
                    justify-content: space-between;      
                    .photo_block{
                        margin-bottom:20px;
                        width:49%;
                    }     
                }
            }
            .photo_type{
                display:flex;
                flex-wrap:wrap;

                .photo_rect{
                    width:120px;
                    margin-right:10px;
                }
                // .photo_rect{
                //     margin-right:20px;
                // }
                .photo_rect:nth-child(2n){
                    margin-right:0;
                }
            }
            .post_list{
                padding-bottom:8px;
                border-bottom:1px solid #eaeef3
            }
        }
        .post_block_full{
            width:100%;
            .marketplace{
                display: flex;
                .cont_wrapper:first-child{
                    padding-right: 100px;            
                }
            }
        }
        .content_empty{
            padding-top:40px;
            text-align:center;
        }

    }
    .recent_posts:nth-child(1) {
        margin-top:0;
    }
}
</style>